import React from 'react';

// Presentational: renders the incomplete/save-error banners. Scrolling the first error into view is owned by
// QuoteBuilderForm's errorScrollTick effect (an always-incrementing tick, so a repeated identical error still
// re-scrolls), which also covers field-level errors -- keeping this component free of scroll side effects.
const MessageAlerts = ({ inCompleteMessage, errorMessage }) => {
  if (!inCompleteMessage && !errorMessage) {
    return null;
  }

  return (
    <>
      {inCompleteMessage && (
        <div className="alert alert-danger fade in">
          <i className="fa fa-exclamation-circle"></i>
          &nbsp;
          <strong>
            <span dangerouslySetInnerHTML={{__html: inCompleteMessage}}></span>
          </strong>
        </div>
      )}

      {errorMessage && (
        <div className="alert alert-danger fade in">
          <i className="fa fa-exclamation-circle"></i>
          &nbsp;
          <strong>
            <span dangerouslySetInnerHTML={{__html: errorMessage}}></span>
          </strong>
        </div>
      )}
    </>
  );
};

export default MessageAlerts;